export function formatEuro(amount: number | null | undefined): string {
  const value = Number(amount || 0);
  return (
    new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(value) +
    " €"
  );
}